import { useEffect } from "react";

export function useLockHorizontalOverscroll() {
  useEffect(() => {
    const targets = [document.documentElement, document.body];
    const previous = targets.map((el) => el.style.overscrollBehaviorX);
    targets.forEach((el) => {
      el.style.overscrollBehaviorX = "none";
    });
    return () => {
      targets.forEach((el, i) => {
        el.style.overscrollBehaviorX = previous[i];
      });
    };
  }, []);
}
